import { erpApi } from "@/shared/axios";
import { urlBackend } from "@/shared/constants";
import { AlertSeverityEnum, SolicitudGremios, SolicitudGremiosForm, SolicitudGremiosParams, SolicitudGremiosResp, UseMutationsParams } from "@/shared/interfaces";

import { getUrlParamsFetch, handleAxiosError } from "@/shared/utils";
import { useUiStore } from "@/store/ui";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { UpdatePreagendamientoParams } from "../operaciones";

const { get, post, put } = erpApi();

///* Obetener todas las solicitudes de extranjero

export const useFetchSolicitudGremios = (params: SolicitudGremiosParams, enabled: boolean = true) => {
  return useQuery({
    queryKey: ['SolicitudAplicaGremios', ...Object.values(params || {})],
    queryFn: async () => {
      return await getSolicitudGremios(params);
    },
    retry: false,
    enabled,
    refetchOnWindowFocus: false,
  });
};

export const getSolicitudGremios = async (params?: SolicitudGremiosParams) => {
  const queryParams = getUrlParamsFetch(params || {});
  const resp = get<SolicitudGremiosResp>(
    `${urlBackend}api/v1/SolicitudAplicaGremios/?${queryParams}`,
    true
  );
  return resp;
};

///* Crear una solicitud de extranjero

export const usePostSolicitudGremios = ({ }: UseMutationsParams) => {
  const queryClient = useQueryClient();

  const setAlert = useUiStore.getState().setAlert;
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;


  return useMutation({

    mutationFn: postSolicitudGremios,
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey: ['SolicitudAplicaGremios'] });
      setAlert(true, data.message, data.status);
    },

    onError: (e => {
      setIsGlobalLoading(false);
      handleAxiosError(e);
    }),
  });
};

export const postSolicitudGremios = async (data: SolicitudGremiosForm) => {
  const res = await post<SolicitudGremios>(`${urlBackend}api/v1/SolicitudAplicaGremios/`, data, true);
  return res;
};

///* Editar una solicitud de extranjero
export const usePutSolicitudGremios = <T>({
  navigate,

  enableRedirect = true,
  returnUrl,

  returnErrorUrl,
  enableErrorRedirect = false,
  customMessageErrorAlert,

  enableSuccessAlert = true,
  customSuccessMessage,

  customSuccessCallback,
}: UseMutationsParams = {}) => {
  const queryClient = useQueryClient();
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
  const setAlert = useUiStore.getState().setAlert;

  return useMutation({
    mutationFn: (params: UpdatePreagendamientoParams<T>) =>
      putSolicitudGremios(params),

    onSuccess: res => {
      queryClient.invalidateQueries({ queryKey: ['SolicitudAplicaGremios'] });

      enableRedirect && navigate && returnUrl && navigate(returnUrl);

      enableSuccessAlert &&
        setAlert &&
        setAlert(
          true,
          customSuccessMessage ?? 'Preagendamiento actualizada correctamente',
          AlertSeverityEnum.success
        );

      customSuccessCallback && customSuccessCallback(res?.data);
    },
    onError: error => {
      enableErrorRedirect &&
        navigate &&
        returnUrl &&
        navigate(returnErrorUrl ?? (returnUrl || ''));

      handleAxiosError(error, customMessageErrorAlert);
    },
    onSettled: () => {
      setIsGlobalLoading(false);
    },
  });
};

export const putSolicitudGremios = async <T>({
  id,
  data,
}: UpdatePreagendamientoParams<T>) => {
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
  setIsGlobalLoading(true);

  return put<SolicitudGremios>(
    `${urlBackend}api/v1/SolicitudAplicaGremios/${id}/`,
    data,
    true
  );
};


///* Buscar una solicitud extranjero por su uid

export const useGetSolicitudGremiosById = (id: string, enabled = false) => {
  return useQuery({
    queryKey: ['SolicitudAplicaGremios', id],
    queryFn: async () => {
      return getSolicitudGremiosById(id);
    },
    enabled,
    refetchOnWindowFocus: false
  });
};

export const getSolicitudGremiosById = async (id: string) => {
  const res = await get<SolicitudGremios>(`${urlBackend}api/v1/SolicitudAplicaGremios/${id}`, true);

  return res.data;
};
